import { useMutation } from "@apollo/client/react";
import GET_USER_GROUPS from "../../queries/rolesAndPermissions/getUserGroups";
import { REMOVE_MEMBER } from "../../mutations/rolesAndPermissions/removeMember";
import GET_USER_GROUP from "../../queries/rolesAndPermissions/getUserGroup";
import GET_USERS from "../../queries/rolesAndPermissions/getUsers";

export const useRemoveMember = ({
  onCompleted,
  onError,
}: {
  onCompleted: (result?: any) => void;
  onError: (e?: any) => void;
}) => {
  const [removeMember, { data, loading, error }] = useMutation(REMOVE_MEMBER, {
    onCompleted: onCompleted,
    onError: onError,
    refetchQueries: [GET_USER_GROUPS, GET_USER_GROUP, GET_USERS],
    awaitRefetchQueries: true,
  });

  return { removeMember, data, loading, error };
};
